import { ShapeKind, LineType, StampType } from '../../drawing/types';
import ObjectDrawingUIAction from '../../actions/ui/ObjectDrawingUIAction';
import { Color } from '../../types/color';

interface ObjectDrawingToolState {
  shapeKind: ShapeKind;
  color: Color;
  lineWidth: number;
  lineType: LineType;
  selectedStampIndex: number;
  stampType: StampType;
}

export interface ObjectDrawingState {
  toolSettings: ObjectDrawingToolState[];
  selected: number;
}

export function initObjectDrawingUIState(): ObjectDrawingState {
  return {
    toolSettings: [{
      shapeKind: ShapeKind.Rect,
      color: Color.Black,
      lineWidth: 1,
      lineType: LineType.Solid,
      selectedStampIndex: 0,
      stampType: StampType.Default,
    }, {
      shapeKind: ShapeKind.Rect,
      color: Color.Black,
      lineWidth: 1,
      lineType: LineType.Solid,
      selectedStampIndex: 0,
      stampType: StampType.Default,
    }, {
      shapeKind: ShapeKind.Rect,
      color: Color.Black,
      lineWidth: 1,
      lineType: LineType.Solid,
      selectedStampIndex: 0,
      stampType: StampType.Default,
    }],
    selected: 0,
  };
}

export const objectDrawing = (
  state: ObjectDrawingState,
  action: ObjectDrawingUIAction.Action,
): ObjectDrawingState => {
  switch (action.type) {
    case ObjectDrawingUIAction.ActionType.SELECT_TOOL: {
      return { ...state, selected: action.selected };
    }
    case ObjectDrawingUIAction.ActionType.SET_SHAPE_KIND: {
      const newToolSettings = [...state.toolSettings];
      newToolSettings[action.selected].shapeKind = action.shapeKind;

      return { ...state, toolSettings: newToolSettings };
    }
    case ObjectDrawingUIAction.ActionType.SET_COLOR: {
      const newToolSettings = [...state.toolSettings];
      newToolSettings[action.selected].color = action.color;

      return { ...state, toolSettings: newToolSettings };
    }
    case ObjectDrawingUIAction.ActionType.SET_LINE_WIDTH: {
      const newToolSettings = [...state.toolSettings];
      newToolSettings[action.selected].lineWidth = action.lineWidth;

      return { ...state, toolSettings: newToolSettings };
    }
    case ObjectDrawingUIAction.ActionType.SET_LINE_TYPE: {
      const newToolSettings = [...state.toolSettings];
      newToolSettings[action.selected].lineType = action.lineType;

      return { ...state, toolSettings: newToolSettings };
    }
    case ObjectDrawingUIAction.ActionType.SELECT_STAMP_TYPE: {
      const newToolSettings = [...state.toolSettings];
      newToolSettings[action.selected].selectedStampIndex = action.selectedStampIndex;
      newToolSettings[action.selected].stampType = action.stampType;
      return { ...state, toolSettings: newToolSettings };
    }
  }
};
